<template>
    <div class="board-view">
        <div class="board-view__tit">
            <h3 class="title01">{{articleInfo.title}}</h3>
            <div class="board-view__tit__right">
                <span class="date" v-if="!hideDate">{{$commonUtils.timestampToDate(articleInfo.createdDt)}}</span>
                <kr_FavoHeart v-if="
                    info
                    && (
                            boardId.includes('vascular') || boardId.includes('health_dic') || boardId.includes('childbirth_class') 
                            || boardId.includes('wellness') || boardId.includes('info_')
                        )

                " :info="info"/>
            </div>
        </div>
        <!-- <div class="board-view__file" v-if="!(this.$route.path.indexOf('health') > -1)"> -->
        <div class="board-view__file" v-if="!(this.$route.path.indexOf('health') > -1 || boardId.indexOf('vascular') > -1 || boardId == 'childbirth_class' || this.$route.path.indexOf('info_') > -1 || boardId.indexOf('wellness') > -1)">
            <template v-if="checkAttach">
                <a href="javascript:;" class="board-view__file--item" v-for="i in attachList" :key="i" @click="this.$commonUtils.fileDownload(i.attachNo, i.displayName)">{{i.displayName}}</a>
            </template>
            <!-- 수정필요(퍼블리싱) -->
            <span href="javascript:;" class="board-view__file--item none" v-else>파일이 없습니다.</span>
        </div>
        <!-- 혈관이야기 -->
        <div class="board-view__cont" v-if="boardId.indexOf('vascularStory') > -1 || boardId.indexOf('wellness_story') > -1">
            <div class="img-wrap" v-if="articleInfo.attachBag.thumbs">
                <img :src="`/displayFile.do?attachNo=${ articleInfo.attachBag.thumbs[0].attachNo }`" :alt="articleInfo.attachBag.thumbs[0].altValue || '이미지'" v-if="articleInfo.attachBag.thumbs">
            </div>
            <div v-html="articleInfo.content" v-if="articleInfo.content"></div>
            <kr_DoctorCard :doctorList="articleInfo.refDoctorList"/>
        </div>
        <!-- 혈관tv -->
        <div class="board-view__cont" v-else-if="boardId.includes('vascularTV') || boardId == 'childbirth_class' || boardId.includes('wellness_tv')">
            <iframe style="width:100%; height: 700px;" :src="`https://www.youtube.com/embed/${$commonUtils.getYoutubeId(articleInfo)}?autoplay=1`" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen v-if="articleInfo.linkUrl"></iframe>
            <div v-html="articleInfo.content" v-if="articleInfo.content"></div>
        </div>
        <!-- 혈액암정보 -->
        <div class="board-view__cont" v-else-if="boardId.indexOf('info_') > -1">
            <div class="sub-lnb-menu">
                <ul class="sub-lnb-menu__list">
                    <template v-for="i in 9" :key="i">
                        <li :class="{'sub-lnb-menu__item': true, 'active': i == 1}" v-if="articleInfo['item' + (i * 2 - 1)]">
                            <div class="line">&nbsp;</div>
                            <a role="button">{{articleInfo['item' + (i * 2 - 1)]}}</a>
                        </li>
                    </template>
                </ul>
            </div>
            <template v-for="i in 9" :key="i">
                <div class="step-item info" :id="`step${i}`" v-if="articleInfo['item' + (i * 2 - 1)]">
                    <h3 class="bullet01">{{articleInfo['item' + (i * 2 - 1)]}}</h3>
                    <div v-html="articleInfo['item' + (i * 2)]"></div>
                </div>
            </template>
        </div>
        <!-- 일반 -->
        <div class="board-view__cont" v-html="articleInfo.content" v-else></div>
        <kr_ArticleNavigation :articleInfo="articleInfo" v-if="!(this.$route.path.indexOf('health') > -1)"/>
    </div>
    <div class="botton-wrap">
        <router-link :to="$route.path.replace('/view', '/list')" class="sub-button c-gray">목록</router-link>
    </div>
</template>

<script>
export default {
    components: { 

    },
    data() {
        return {
            boardNo: this.$route.query.boardNo || '',
            articleNo: this.$route.query.articleNo || '',
            articleInfo: '',
            attachList: '',
            boardId: '',
            info: null,
        };
    },
    watch: {
        $route(to, from) {
            for (let i in this.$route.query) {
                this[i] = this.$route.query[i];
            }
            this.getView();
        }
    },
    computed: {
        checkAttach() {
            if (this.articleInfo.attachBag) {
                if (this.articleInfo.attachBag.attach != null) {
                    return true;
                }
            }
            return false;
        },
        hideDate() {
            const host = window.location.hostname;   
            const path = this.$route.path;          

            return (
                (host === 'aorta.eumc.ac.kr'   && path === '/kr/vascularStory/view') ||
                (host === 'ewhabrain.eumc.ac.kr' && path === '/kr/br_vascularStory/view')
            );
        }
    },
    methods: {
        getView() {
            this.axios
                .get(this.api.article.view + this.boardNo + '/' + this.articleNo, {
                    params: {
                        hospId: this.$store.getters.getHost,
                        articleNo: this.articleNo,
                        boardNo: this.boardNo
                    }
                })
                .then((res) => {
                    this.articleInfo = res.data;
                    this.boardId = res.data.boardId || ''
                    this.attachList = res.data.attachBag.attach;

                    this.info = {
                        favoYn: res.data.favoInfoYn === 'Y' ? 'Y' : 'N',
                        no: this.articleNo,
                        type: 'BBS',
                        doctorDetail: false
                    };

                    // 혈액암정보 게시판
                    if(this.boardId.includes('info_')){
                        function handleScroll(){
                            var sections = document.querySelectorAll('.step-item');
                            sections.forEach((section, index) => {
                                const rect = section.getBoundingClientRect();
                                if (rect.top <= 101 && rect.top <= window.innerHeight) {
                                    const items = document.querySelectorAll('.sub-lnb-menu__item')
                                    items.forEach((item, idx) => {
                                        if(index == idx){
                                            item.classList.add('active');
                                        }else{
                                            item.classList.remove('active');
                                        }
                                    })
                                }
                            });
                        }
                        function scrollTo(index) {
                            const element = document.querySelectorAll('.step-item')[index];
                            if (element) {
                                const elementTop = element.getBoundingClientRect().top + window.pageYOffset;
                                const scrollToPosition = elementTop - 100;

                                document.querySelector('html').scrollTo({ top: scrollToPosition, behavior: 'smooth' });
                            }
                        }
                        this.$nextTick(()=>{
                            window.addEventListener('scroll', handleScroll);
                            const elements = document.querySelectorAll('.sub-lnb-menu__item');
                            elements.forEach((element, index) => {
                                element.addEventListener('click', () => scrollTo(index))
                            })
                        })
                    }
                });
        },
        scrollTo(index) {
            const element = document.querySelectorAll('.step-item')[index];
            if (element) {
                const elementTop = element.getBoundingClientRect().top + window.pageYOffset;
                const scrollToPosition = elementTop - 100;

                window.scrollTo({top: scrollToPosition, behavior: 'smooth'});
            }
        },
        handleScroll() {
            const sections = document.querySelectorAll('.step-item');
            sections.forEach((section, index) => {
                const rect = section.getBoundingClientRect();
                if (rect.top <= 101 && rect.top <= window.innerHeight) {
                    const items = document.querySelectorAll('.sub-lnb-menu__item')
                    items.forEach((item, idx) => {
                        if(index == idx){
                            item.classList.add('active');
                        }else{
                            item.classList.remove('active');
                        }
                    })
                }
            });
        },
        lnbFn(index) {
            this.lnbIndex = index; // Change the active index when clicking the menu
        },
    },
    mounted() {
        this.getView();
    }
};
</script>

<style scoped></style>
